import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { FestiveRibbon } from "@/components/site/FestiveRibbon";
import { MudToysTeaser } from "@/components/site/MudToysTeaser";
import { Manifesto } from "@/components/site/Manifesto";
import { Footer } from "@/components/site/Footer";
import { FloralBackdrop } from "@/components/site/FloralBackdrop";
import { ChatWidget } from "@/components/site/ChatWidget";
import { ErrorBoundary } from "@/components/site/ErrorBoundary";
import Philosophy from "@/pages/Philosophy";
import Collection from "@/pages/Collection";
import Festivals from "@/pages/Festivals";
import Exclusive from "@/pages/Exclusive";
import FounderPage from "@/pages/FounderPage";
import SacredEssentials from "@/pages/SacredEssentials";
import Admin from "@/pages/Admin";
import Cart from "@/pages/Cart";
import { Toaster } from "@/components/ui/sonner";
import { MessageCircle } from "lucide-react";

const Home = () => (
  <main>
    <Hero />
    <EditorialMarquee />
    <FestiveRibbon />
    <MudToysTeaser />
    <Manifesto />
  </main>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ErrorBoundary>
      <div className="relative min-h-screen bg-brand-ivory" data-testid="laxwedeepan-site">
        <div className="grain-overlay" aria-hidden="true" />
        <FloralBackdrop />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/philosophy" element={<Philosophy />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/festivals" element={<Festivals />} />
          <Route path="/exclusive" element={<Exclusive />} />
          <Route path="/founder" element={<FounderPage />} />
          <Route path="/essentials" element={<SacredEssentials />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/cart" element={<Cart />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-left" />
        <ChatWidget />
        <a
          href="https://wa.me/919205511502?text=Namaste%20Laxwedeepan%2C%20I%20would%20like%20to%20enquire%20about%20your%20products."
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float-button"
          aria-label="Chat with Laxwedeepan on WhatsApp"
          className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand-peach text-white shadow-lg transition-transform duration-300 hover:scale-110"
        >
          <MessageCircle className="h-6 w-6" strokeWidth={1.5} />
        </a>
      </div>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
